var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbnail3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 225,
    viewBox: "0 0 328 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328 0H0V225H328V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 30.3047H9.50732V37.1684H96.974V30.3047Z",
    stroke: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 85.2139H9.50732V92.0776H96.974V85.2139Z",
    stroke: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 140.119H9.50732V146.983H96.974V140.119Z",
    stroke: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 57.7578H9.50732V64.6216H96.974V57.7578Z",
    stroke: "#CCCCCC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 112.668H9.50732V119.532H96.974V112.668Z",
    stroke: "#CCCCCC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 167.581H9.50732V174.445H96.974V167.581Z",
    stroke: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 44.0293H9.50732V50.8931H96.974V44.0293Z",
    stroke: "#CCCCCC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 98.9385H9.50732V105.802H96.974V98.9385Z",
    stroke: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 153.853H9.50732V160.716H96.974V153.853Z",
    stroke: "#CCCCCC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 71.4834H9.50732V78.3472H96.974V71.4834Z",
    stroke: "#CCCCCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 126.398H9.50732V133.262H96.974V126.398Z",
    stroke: "#CCCCCC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 181.307H9.50732V188.17H96.974V181.307Z",
    stroke: "#CCCCCC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 195.033H9.50732V201.897H96.974V195.033Z",
    stroke: "#CCCCCC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 37.168H9.50732V44.0317H96.974V37.168Z",
    stroke: "#CCCCCC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 92.0771H9.50732V98.9409H96.974V92.0771Z",
    stroke: "#CCCCCC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 146.987H9.50732V153.851H96.974V146.987Z",
    stroke: "#CCCCCC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 64.6211H9.50732V71.4848H96.974V64.6211Z",
    stroke: "#CCCCCC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 119.529H9.50732V126.393H96.974V119.529Z",
    stroke: "#CCCCCC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 174.445H9.50732V181.309H96.974V174.445Z",
    stroke: "#CCCCCC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 50.8926H9.50732V57.7563H96.974V50.8926Z",
    stroke: "#CCCCCC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 105.805H9.50732V112.668H96.974V105.805Z",
    stroke: "#CCCCCC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 160.716H9.50732V167.58H96.974V160.716Z",
    stroke: "#CCCCCC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 78.3506H9.50732V85.2143H96.974V78.3506Z",
    stroke: "#CCCCCC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 133.26H9.50732V140.124H96.974V133.26Z",
    stroke: "#CCCCCC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 188.166H9.50732V195.03H96.974V188.166Z",
    stroke: "#CCCCCC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 201.893H9.50732V208.756H96.974V201.893Z",
    stroke: "#CCCCCC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 208.762H9.50732V215.625H96.974V208.762Z",
    stroke: "#CCCCCC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 30.3047H96.9736V37.1684H148.313V30.3047Z",
    stroke: "#CCCCCC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 85.2139H96.9736V92.0776H148.313V85.2139Z",
    stroke: "#CCCCCC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 140.119H96.9736V146.983H148.313V140.119Z",
    stroke: "#CCCCCC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 57.7578H96.9736V64.6216H148.313V57.7578Z",
    stroke: "#CCCCCC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 112.668H96.9736V119.532H148.313V112.668Z",
    stroke: "#CCCCCC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 167.581H96.9736V174.445H148.313V167.581Z",
    stroke: "#CCCCCC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 44.0293H96.9736V50.8931H148.313V44.0293Z",
    stroke: "#CCCCCC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 98.9385H96.9736V105.802H148.313V98.9385Z",
    stroke: "#CCCCCC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 153.853H96.9736V160.716H148.313V153.853Z",
    stroke: "#CCCCCC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 71.4834H96.9736V78.3472H148.313V71.4834Z",
    stroke: "#CCCCCC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 126.398H96.9736V133.262H148.313V126.398Z",
    stroke: "#CCCCCC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 181.307H96.9736V188.17H148.313V181.307Z",
    stroke: "#CCCCCC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 195.033H96.9736V201.897H148.313V195.033Z",
    stroke: "#CCCCCC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 37.168H96.9736V44.0317H148.313V37.168Z",
    stroke: "#CCCCCC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 92.0771H96.9736V98.9409H148.313V92.0771Z",
    stroke: "#CCCCCC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 146.987H96.9736V153.851H148.313V146.987Z",
    stroke: "#CCCCCC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 64.6211H96.9736V71.4848H148.313V64.6211Z",
    stroke: "#CCCCCC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 119.529H96.9736V126.393H148.313V119.529Z",
    stroke: "#CCCCCC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 174.445H96.9736V181.309H148.313V174.445Z",
    stroke: "#CCCCCC"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 50.8926H96.9736V57.7563H148.313V50.8926Z",
    stroke: "#CCCCCC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 105.805H96.9736V112.668H148.313V105.805Z",
    stroke: "#CCCCCC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 160.716H96.9736V167.58H148.313V160.716Z",
    stroke: "#CCCCCC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 78.3506H96.9736V85.2143H148.313V78.3506Z",
    stroke: "#CCCCCC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 133.26H96.9736V140.124H148.313V133.26Z",
    stroke: "#CCCCCC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 188.166H96.9736V195.03H148.313V188.166Z",
    stroke: "#CCCCCC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 201.893H96.9736V208.756H148.313V201.893Z",
    stroke: "#CCCCCC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 208.762H96.9736V215.625H148.313V208.762Z",
    stroke: "#CCCCCC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M96.974 23.4365H9.50732V30.3003H96.974V23.4365Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M148.313 23.4365H96.9736V30.3003H148.313V23.4365Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 30.3047H232.928V37.1684H318.493V30.3047Z",
    stroke: "#CCCCCC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 85.2139H232.928V92.0776H318.493V85.2139Z",
    stroke: "#CCCCCC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 140.119H232.928V146.983H318.493V140.119Z",
    stroke: "#CCCCCC"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 57.7578H232.928V64.6216H318.493V57.7578Z",
    stroke: "#CCCCCC"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 112.668H232.928V119.532H318.493V112.668Z",
    stroke: "#CCCCCC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 167.581H232.928V174.445H318.493V167.581Z",
    stroke: "#CCCCCC"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 44.0293H232.928V50.8931H318.493V44.0293Z",
    stroke: "#CCCCCC"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 98.9385H232.928V105.802H318.493V98.9385Z",
    stroke: "#CCCCCC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 153.853H232.928V160.716H318.493V153.853Z",
    stroke: "#CCCCCC"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 71.4834H232.928V78.3472H318.493V71.4834Z",
    stroke: "#CCCCCC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 126.398H232.928V133.262H318.493V126.398Z",
    stroke: "#CCCCCC"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 181.307H232.928V188.17H318.493V181.307Z",
    stroke: "#CCCCCC"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 195.033H232.928V201.897H318.493V195.033Z",
    stroke: "#CCCCCC"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 37.168H232.928V44.0317H318.493V37.168Z",
    stroke: "#CCCCCC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 92.0771H232.928V98.9409H318.493V92.0771Z",
    stroke: "#CCCCCC"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 146.987H232.928V153.851H318.493V146.987Z",
    stroke: "#CCCCCC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 64.6211H232.928V71.4848H318.493V64.6211Z",
    stroke: "#CCCCCC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 119.529H232.928V126.393H318.493V119.529Z",
    stroke: "#CCCCCC"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 174.445H232.928V181.309H318.493V174.445Z",
    stroke: "#CCCCCC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 50.8926H232.928V57.7563H318.493V50.8926Z",
    stroke: "#CCCCCC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 105.805H232.928V112.668H318.493V105.805Z",
    stroke: "#CCCCCC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 160.716H232.928V167.58H318.493V160.716Z",
    stroke: "#CCCCCC"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 78.3506H232.928V85.2143H318.493V78.3506Z",
    stroke: "#CCCCCC"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 133.26H232.928V140.124H318.493V133.26Z",
    stroke: "#CCCCCC"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 188.166H232.928V195.03H318.493V188.166Z",
    stroke: "#CCCCCC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 201.893H232.928V208.756H318.493V201.893Z",
    stroke: "#CCCCCC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 208.762H232.928V215.625H318.493V208.762Z",
    stroke: "#CCCCCC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 30.3047H148.313V37.1684H232.928V30.3047Z",
    stroke: "#CCCCCC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 85.2139H148.313V92.0776H232.928V85.2139Z",
    stroke: "#CCCCCC"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 140.119H148.313V146.983H232.928V140.119Z",
    stroke: "#CCCCCC"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 57.7578H148.313V64.6216H232.928V57.7578Z",
    stroke: "#CCCCCC"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 112.668H148.313V119.532H232.928V112.668Z",
    stroke: "#CCCCCC"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 167.581H148.313V174.445H232.928V167.581Z",
    stroke: "#CCCCCC"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 44.0293H148.313V50.8931H232.928V44.0293Z",
    stroke: "#CCCCCC"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 98.9385H148.313V105.802H232.928V98.9385Z",
    stroke: "#CCCCCC"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 153.853H148.313V160.716H232.928V153.853Z",
    stroke: "#CCCCCC"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 71.4834H148.313V78.3472H232.928V71.4834Z",
    stroke: "#CCCCCC"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 126.398H148.313V133.262H232.928V126.398Z",
    stroke: "#CCCCCC"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 181.307H148.313V188.17H232.928V181.307Z",
    stroke: "#CCCCCC"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 195.033H148.313V201.897H232.928V195.033Z",
    stroke: "#CCCCCC"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 37.168H148.313V44.0317H232.928V37.168Z",
    stroke: "#CCCCCC"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 92.0771H148.313V98.9409H232.928V92.0771Z",
    stroke: "#CCCCCC"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 146.987H148.313V153.851H232.928V146.987Z",
    stroke: "#CCCCCC"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 64.6211H148.313V71.4848H232.928V64.6211Z",
    stroke: "#CCCCCC"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 119.529H148.313V126.393H232.928V119.529Z",
    stroke: "#CCCCCC"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 174.445H148.313V181.309H232.928V174.445Z",
    stroke: "#CCCCCC"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 50.8926H148.313V57.7563H232.928V50.8926Z",
    stroke: "#CCCCCC"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 105.805H148.313V112.668H232.928V105.805Z",
    stroke: "#CCCCCC"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 160.716H148.313V167.58H232.928V160.716Z",
    stroke: "#CCCCCC"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 78.3506H148.313V85.2143H232.928V78.3506Z",
    stroke: "#CCCCCC"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 133.26H148.313V140.124H232.928V133.26Z",
    stroke: "#CCCCCC"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 188.166H148.313V195.03H232.928V188.166Z",
    stroke: "#CCCCCC"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 201.893H148.313V208.756H232.928V201.893Z",
    stroke: "#CCCCCC"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 208.762H148.313V215.625H232.928V208.762Z",
    stroke: "#CCCCCC"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 23.4365H232.928V30.3003H318.493V23.4365Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 23.4365H148.313V30.3003H232.928V23.4365Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5653 9.37402H9.50732V14.0615H85.5653V9.37402Z",
    fill: "#E0E0E0"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M318.493 9.37402H90.3193V14.0615H318.493V9.37402Z",
    fill: "#E0E0E0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail3);
export default __webpack_public_path__ + "static/media/thumbnail-3.8c3fb8f658d2a2f4ca043e14659c5f89.svg";
export { ForwardRef as ReactComponent };